module.exports = {
      id: "envelope-usage",
      viewBox: "0 0 160 120",
      url: __webpack_public_path__ + "svg-sprite-39dbc991ee8a2ec1b35aeef6495011e2.svg#envelope",
      toString: function () {
        return this.url;
      }
    }